export default {
  title: 'Administrer konto',
  buttons: {
    save: 'Gem',
    delete: 'Slet',
  },
};
